/** Фирменные цвета мессенджеров — одни на значок канала «Обращений» и пилюлю источника доски (`s635`). */
export const CVETA_MESSENDZHEROV: Record<string, string> = {
  whatsapp: '#25D366',
  telegram: '#229ED9',
  vk: '#0077FF',
  max: '#8B5CF6',
};
